/* "Buy the set" helpers for the MBC Bundles widget.

   The bundle card is drawn by the MBC Bundles app, so its markup is not ours
   to edit. This file waits for the widget to render and does two things:

   1. Default finish. Until the customer deliberately picks Tough MagSafe, any
      bundle dropdown that lands on it is moved to a preferred finish (Gold
      lens first, then Silver lens), looking in this order:
        a. the phone selected on the product page,
        b. the phone the bundle opened on,
        c. the first phone in the list that has the finish in stock.
      Step (c) covers models such as the iPhone 18 range, where only Tough
      MagSafe is sold for now.

   2. Colour note. A note at the bottom of each bundle card shows only while
      Tough MagSafe -- the finish that prints differently -- is selected. */
(function(){
"use strict";

var TAG = document.currentScript || document.querySelector("script[data-bundle-note]");
if (!TAG) return;

function low(s){ return String(s || "").toLowerCase(); }

var NOTE = TAG.getAttribute("data-note") || "";
var MATCH = low(TAG.getAttribute("data-match")).trim();
var ALWAYS = TAG.getAttribute("data-always") === "true";
var PREFER = low(TAG.getAttribute("data-prefer")).split(",")
  .map(function(s){ return s.trim(); })
  .filter(Boolean);

/* Set once the customer picks Tough MagSafe themselves -- in the bundle or in
   the main variant picker -- and cleared if they pick another finish. While it
   is set, nothing is switched for them. */
var chosen = false;

/* Phone model selected on the product page (see pagePhone below). */
var PAGE_KEY = "";

document.addEventListener("change", function(ev){
  if (!ev.isTrusted || !MATCH) return;
  var el = ev.target;
  if (!el) return;
  var text = low(el.value);
  if (el.tagName === "SELECT"){
    var o = el.options[el.selectedIndex];
    if (o) text += " " + low(o.text);
  }
  if (text.indexOf(MATCH) > -1){ chosen = true; return; }
  for (var i=0;i<PREFER.length;i++){
    if (text.indexOf(PREFER[i]) > -1){ chosen = false; return; }
  }
  /* A phone-model change says nothing about the finish, so it is ignored. */
}, true);

/* What is left of an option once the finish and any price / stock wording is
   taken out -- normally just the phone model. Two options with the same key
   are the same phone in different finishes. Extra spaces in variant names
   ("IPHONE  18 PRO") collapse, so they still match. */
function key(text){
  var t = low(text);
  if (MATCH) t = t.split(MATCH).join(" ");
  for (var i=0;i<PREFER.length;i++) t = t.split(PREFER[i]).join(" ");
  return t
    .replace(/magsafe/g, " ")
    .replace(/sold out|unavailable|pre-?order/g, " ")
    .replace(/[$€£]?\s?\d+[.,]\d{2}/g, " ")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

/* An option in the preferred finish that can be bought; when phone is given
   it must also be that phone. Options are searched in list order. */
function find(sel, pref, phone){
  for (var i=0;i<sel.options.length;i++){
    var o = sel.options[i];
    if (o.disabled) continue;
    var t = low(o.text);
    if (t.indexOf(MATCH) > -1 || t.indexOf(pref) < 0) continue;
    if (/sold out|unavailable/.test(t)) continue;
    if (phone && key(o.text) !== phone) continue;
    return o;
  }
  return null;
}

function swap(sel){
  var cur = sel.options[sel.selectedIndex];
  if (!cur || low(cur.text).indexOf(MATCH) < 0) return false;

  var phones = [];
  if (PAGE_KEY) phones.push(PAGE_KEY);
  var here = key(cur.text);
  if (here && phones.indexOf(here) < 0) phones.push(here);
  phones.push("");                       /* "" = any phone, first in stock */

  for (var k=0;k<phones.length;k++){
    for (var p=0;p<PREFER.length;p++){
      var o = find(sel, PREFER[p], phones[k]);
      if (!o) continue;
      sel.value = o.value;
      sel.dispatchEvent(new Event("input", { bubbles:true }));
      sel.dispatchEvent(new Event("change", { bubbles:true }));
      return true;
    }
  }
  return false;   /* no preferred finish in stock anywhere -- leave it */
}

/* The variant selected in the product page's own form (not the bundle's). */
function pageVariantId(){
  var inputs = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
  for (var i=0;i<inputs.length;i++){
    if (inputs[i].closest("#mbcBundleItemsWidget, .mbc-bundle")) continue;
    if (inputs[i].value) return String(inputs[i].value);
  }
  var m = location.search.match(/[?&]variant=(\d+)/);
  return m ? m[1] : "";
}

/* Works out PAGE_KEY, then calls done(). Uses the selected-variant JSON Dawn
   prints next to the variant picker, or the product's .js feed as a fallback. */
function pagePhone(done){
  var finished = false;
  function end(){ if (!finished){ finished = true; done(); } }
  setTimeout(end, 3000);                 /* never hold the bundle up for long */

  try {
    var js = document.querySelector("variant-selects [data-selected-variant]");
    if (js){
      var v = JSON.parse(js.textContent);
      if (v && (v.option1 || v.title)){ PAGE_KEY = key(v.option1 || v.title); return end(); }
    }
  } catch(e){}

  var id = pageVariantId();
  var m = location.pathname.match(/\/products\/[^\/?#]+/);
  if (!id || !m || !window.fetch) return end();
  fetch(m[0] + ".js", { credentials:"same-origin" })
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(prod){
      var vs = (prod && prod.variants) || [];
      for (var i=0;i<vs.length;i++){
        if (String(vs[i].id) === id){ PAGE_KEY = key(vs[i].option1 || vs[i].title); break; }
      }
      end();
    })
    .catch(end);
}

function noteFor(bundle){
  var n = bundle.querySelector(".bundle-note");
  if (n) return n;
  n = document.createElement("p");
  n.className = "bundle-note";
  var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("class", "bundle-note__i");
  svg.setAttribute("viewBox", "0 0 20 20");
  svg.setAttribute("fill", "none");
  svg.setAttribute("aria-hidden", "true");
  svg.innerHTML =
    '<circle cx="10" cy="10" r="8.2" stroke="currentColor" stroke-width="1.5"/>' +
    '<path d="M10 9v5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>' +
    '<circle cx="10" cy="6.2" r="1.05" fill="currentColor"/>';
  var span = document.createElement("span");
  span.textContent = NOTE;
  n.appendChild(svg);
  n.appendChild(span);
  bundle.appendChild(n);
  return n;
}

/* True while one of this bundle's dropdowns sits on the finish named in the
   section settings. */
function picked(bundle){
  if (ALWAYS || !MATCH) return true;
  var sels = bundle.querySelectorAll("select");
  for (var i=0;i<sels.length;i++){
    var o = sels[i].options[sels[i].selectedIndex];
    if (o && low(o.text).indexOf(MATCH) > -1) return true;
  }
  return false;
}

function paint(){
  var bundles = document.querySelectorAll(".mbc-bundle");
  for (var i=0;i<bundles.length;i++){
    if (!chosen && MATCH && PREFER.length){
      var sels = bundles[i].querySelectorAll("select");
      for (var s=0;s<sels.length;s++) swap(sels[s]);
    }
    if (NOTE){
      var n = noteFor(bundles[i]);
      n.hidden = !picked(bundles[i]);
    }
  }
  return bundles.length;
}

var timer = null;
function schedule(){ clearTimeout(timer); timer = setTimeout(paint, 60); }

function watch(host){
  paint();
  /* The app re-renders its card whenever a variant changes, which would drop
     the note, so it is put back each time. */
  var mo = new MutationObserver(function(muts){
    for (var i=0;i<muts.length;i++){
      var t = muts[i].target;
      if (t && t.classList && t.classList.contains("bundle-note")) continue;
      schedule();
      return;
    }
  });
  mo.observe(host, { childList:true, subtree:true });
  host.addEventListener("change", schedule);
}

/* The widget is injected by the app after the page loads, so wait for it
   rather than assuming it is there -- then stop looking. */
function start(){
  pagePhone(function(){
    var tries = 0;
    (function look(){
      var host = document.getElementById("mbcBundleItemsWidget");
      if (host && host.querySelector(".mbc-bundle")){ watch(host); return; }
      if (++tries > 40) return;          /* ~20s, then give up quietly */
      setTimeout(look, 500);
    })();
  });
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
else start();

})();
